import React, { useEffect } from "react";
// import "./orderTable.css";
import "./table.css";
import styled from "@emotion/styled";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderRadius: "15px",

    maxWidth: "50rem",
    height: "32rem",
    overflowY: "scroll",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const PlaceOrderTable = ({
  maxWidth = "60rem",
  orderProducts,
  updateCFAOrder,
}) => {
  useEffect(() => {
    console.log(orderProducts);
  }, []);
  return (
    <div className="">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table">
          <tr className="table-rows">
            <th className="table-heads text-dark " width={"2%"}>
              #
            </th>
            <th className="table-heads text-dark" width={"11%"}>
              Product Name
            </th>
            <th className="table-heads text-dark" width={"4%"}>
              Qty
            </th>
            <th className="table-heads text-dark" width={"4%"}>
              Price
            </th>
            <th className="table-heads text-dark" width={"8%"}>
              Required Qty
            </th>
          </tr>
          {orderProducts.map((odr, index) => (
            <tr className="table-rows1" key={index}>
              <td className="table-each-row-data color_747f9e">{index + 1}</td>
              <td className="table-each-row-data color_747f9e">
                {odr?.product?.product_name}
              </td>
              <td className="table-each-row-data color_747f9e">
                {odr?.quantity}
              </td>
              <td className="table-each-row-data color_747f9e">
                ₹ {odr?.price}
              </td>
              <td className="table-each-row-data color_747f9e">
                <input
                  type="number"
                  className="w-75 table-input px-2 py-1"
                  placeholder="Enter qty"
                  onChange={(e) => updateCFAOrder(e, odr)}
                />
              </td>
            </tr>
          ))}
        </table>
      </TableContainer>
    </div>
  );
};

export default PlaceOrderTable;
